import { format, parse } from 'date-fns'
import React, { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { AuthSessionContext } from '@context/AuthContext'
import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { formatDate, getLastBusinessDayOfMonth } from '@utils/date.utils'

import { NameDto } from '@model/NameDto'

interface Props {
  dueDate?: string
}

export const PendingUnsubscriptionModal: BaseModalType<Props> = ({ close, dueDate }) => {
  const { t } = useTranslation()
  const [auth] = useContext(AuthSessionContext)
  const formattedDueDate = getDates(auth?.dateFormatType, dueDate)
  return (
    <Modal>
      <Modal.Header>{t('Subscriptions.Pending Unsubscription')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          <p className='text'>{t('Market Data.Pending Unsubscription Message.line1')}</p>
          <p className='text mb-2'>
            <Trans
              i18nKey={'Market Data.Pending Unsubscription Message.line2'}
              values={{ dueDate: formattedDueDate }}
              components={[<strong />]}
            />
          </p>
          <p className='text'>{t('Market Data.Pending Unsubscription Message.line3')}</p>
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}

const getDates = (dateFormatType?: NameDto, dueDate?: string): string => {
  if (!dueDate) {
    return ''
  }

  const dueDateFormatted = formatDate(dueDate || '', { formatType: 'dd.MM.yyyy' })

  const dateFormat = dateFormatType?.name ?? ''
  const parsedDueDate = parse(dueDateFormatted, 'dd.MM.yyyy', new Date())

  const lastBusinessDayOfMonth = getLastBusinessDayOfMonth().getDate(parsedDueDate)
  return format(lastBusinessDayOfMonth, dateFormat || 'yyyy-MM-dd')
}
